import { Box, Button, TextField, Typography, useTheme } from "@mui/material";
import { ChangeEvent, FormEvent, useState } from "react";
import useSendResetPasswordEmail from "../../services/useSendResetPasswordEmail";
import { useNavigate } from "react-router-dom";
import validateEmail from "../../utils/validateEmail";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [email, setEmail] = useState("");
  const [notFound, setNotFound] = useState(false);
  const [emailError, setEmailError] = useState<string | null>(null);
  const { mutate, isSuccess } = useSendResetPasswordEmail();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);

    // Validação de formato de email em tempo real
    const error = validateEmail(value);
    setEmailError(error);
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setNotFound(false);

    // Verifica se há erro de formato antes de enviar
    if (emailError) {
      return;
    }

    mutate(email, {
      onError: (error) => {
        const response = error as Response;
        if (response.status === 404) {
          setNotFound(true);
        }
      },
    });
  };

  const goToLogin = () => {
    navigate("/login");
  };

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        height: "100vh",
        justifyContent: "center",
      }}
    >
      <Typography variant="body1">
        Preencha seu email para te enviaremos um link para registro de uma nova
        senha
      </Typography>
      <form onSubmit={handleSubmit}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <TextField
            label="E-mail"
            onChange={handleChange}
            required
            value={email}
            error={emailError !== null}
            helperText={emailError}
          />
          <Button
            disabled={email === "" || emailError !== null}
            onClick={handleSubmit}
            type="submit"
            variant="contained"
          >
            Enviar
          </Button>
        </Box>
      </form>
      <Button color="primary" onClick={goToLogin} sx={{ width: "230px" }}>
        Voltar
      </Button>
      {notFound && (
        <Typography color={theme.palette.error.main}>
          Email não encontrado, talvez você tenha cadastrado outro email.
        </Typography>
      )}
      {isSuccess && (
        <Typography color={theme.palette.primary.main}>
          Email enviado com sucesso. Siga as instruções no email enviado para o
          endereço acima.
        </Typography>
      )}
    </Box>
  );
};

export default ForgotPassword;
